export default "__VITE_ASSET__CJcI3zSv__"